'use client'

import {FC} from 'react'

import {BreadcrumbStep} from '@/app/lib/structuredData'
import {BrandProtectionGuideCardList} from '@/components/brand-monitoring/guide/BrandProtectionGuideCardList'
import {BrandProtectionGuideContentLayout} from '@/components/brand-monitoring/guide/BrandProtectionGuideContentLayout'
import {GetStartedWithVerificationBanner} from '@/components/common/banner/GetStartedWithVerificationBanner'
import {Breadcrumbs} from '@/components/common/content/Breadcrumbs'
import {Section} from '@/components/common/content/Section'
import {Hero} from '@/components/common/hero/Hero'
import {Page} from '@/components/Page'
import {getBrandMonitoringGuideContent} from '@/content/brand-monitoring/brandMonitoringGuide'
import {useTranslation} from '@/i18n'
import {BrandProtectionGuideBasicInfo, BrandProtectionGuideContent} from '@/utils/contentful'
import {routeTo} from '@/utils/router'

type BrandProtectionGuidePlatformProps = {
  allPlatforms: BrandProtectionGuideBasicInfo[]
  brandProtectionPlatformGuide: BrandProtectionGuideContent
  breadcrumbTrail: BreadcrumbStep[]
}

const BrandProtectionGuidePlatform: FC<BrandProtectionGuidePlatformProps> = ({
  allPlatforms,
  brandProtectionPlatformGuide,
  breadcrumbTrail,
}) => {
  const {t} = useTranslation()
  const {otherPlatformsTitle, getStartedBanner, helpCenterCategories} =
    getBrandMonitoringGuideContent()
  const {platformKey, platformTitle, title, subtitle} = brandProtectionPlatformGuide

  const otherPlatforms = allPlatforms.filter((platform) => platform.platformKey !== platformKey)

  return (
    <Page helpCenterCategories={helpCenterCategories}>
      <Hero
        title={title}
        subtitle={subtitle}
        breadcrumbs={<Breadcrumbs trail={breadcrumbTrail} hideCurrent />}
        maxWidth="100%"
      />
      <Section hasPaddingTop>
        <BrandProtectionGuideContentLayout brandProtectionGuide={brandProtectionPlatformGuide} />
      </Section>
      <Section hasPaddingTop>
        <BrandProtectionGuideCardList
          title={t(otherPlatformsTitle)}
          cards={otherPlatforms}
          numOfCardsPerRow={4}
          showDescription={false}
        />
      </Section>
      <GetStartedWithVerificationBanner
        title={t(getStartedBanner.title)}
        primaryButtonLink={routeTo.brandMonitoring.order()}
        primaryButtonText={t(getStartedBanner.primaryButtonText)}
        primaryButtonTrackedEvent={`GetStartedBanner-BrandProtectionGuide${platformTitle}`}
        hasPaddingTop
      />
    </Page>
  )
}

export default BrandProtectionGuidePlatform
